const DistanceComponent = (value, t) =>
  value ? t('global.uniteKm', { value: Math.round(value) }) : null
export default DistanceComponent
